export default "__VITE_ASSET__DPkyHT7R__"